import IncomingWebhookDisplay from './IncomingWebhookDisplay.container'
import IncomingWebhookForm from './IncomingWebhookForm.container'
import IconWebhook from 'components/Icons/Webhook'

export default {
  id: 'incoming_webhook',
  label: 'Incoming Webhook',
  helpUrl: 'https://help.thinkpickle.com.au/flows/triggers/incoming-webhook',
  icon: IconWebhook,
  inputs: [],
  outputs: [{}],
  display: IncomingWebhookDisplay,
  form: IncomingWebhookForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingWebhook/index.js